import type { ClientDashboard } from "@/types/clientDashboard";

import { orgApiFetch } from "./orgApiFetch";

export function fetchClientDashboard(): Promise<ClientDashboard> {
    return orgApiFetch<ClientDashboard>("/api/org/client/dashboard");
}
